import { FC, ReactNode } from "react";

interface Props {
  title: ReactNode;
  LinkComponent?: ReactNode;
}

const RLCardLinkHeader: FC<Props> = ({ title, LinkComponent }) => (
  <div
    style={{
      background: "#f5f5f5",
      cursor: "default",
      height: "44px",
      padding: "1rem"
    }}
    className="flex flex-space-between align-center "
  >
    <div style={{ fontSize: "18px", fontWeight: 700 }}>{title}</div>
    {LinkComponent}
  </div>
);

export default RLCardLinkHeader;
